import type { SbBlokData, StoryblokTable } from '@cinch-nx/data-storyblok'

export const toTableSbBlokData = (
  table?: SbBlokData[] | StoryblokTable,
): SbBlokData[] => {
  if (!table) {
    return []
  }

  if (Array.isArray(table)) {
    return table
  }

  const uid =
    table.thead?.[0]?._uid ?? table.tbody?.[0]?._uid ?? 'table-section-table'

  return [
    {
      _uid: uid,
      component: 'Table',
      ...table,
    } as SbBlokData,
  ]
}
